/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { FormEvent, useEffect, useState } from "react";
import summaryStyle from "../../Common/Style/summaryStyle";
import Grid from "@mui/material/Grid";
import { Link, useLocation, useNavigate } from "react-router";
import Paper from "@mui/material/Paper";
import TextContainer from "../../../Container/TextContainer";
import PersonalData from "./Summary/PersonalData";
import { formValue } from "../../../../services/formServiceFunctions";
import CategoryData from "./Summary/CategoryData";
import _get from "lodash/get";
import translations from "../../../../services/death/translations";
import Button from "@mui/material/Button";
import ButtonLoading from "../../../Button/ButtonLoading";
import { toCheckout } from "../../../../services/checkoutService";
import EmailVerificationModal from "../../../FormInfoModal/EmailVerificationModal";
import { getCaseLink } from "../../../../services/productService";
import { useForm } from "../../../../provider/Form/FormProvider";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import { requiredValidator } from "../../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys, updateResource } from "../../../../services/reactQuery/reactQueryService";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type SummaryProps = { product: AbstractCase };

export default function Summary({ product }: SummaryProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { values } = useForm();
  const queryClient = useQueryClient();
  const updateMutation = useMutation({
    mutationFn: updateResource,
    onSuccess: (data, variables) => queryClient.setQueryData(queryKeys.item(variables.uri, data.id), data),
  });

  const [isLoading, setIsLoading] = useState(false);

  const stateField = location.state?.field;

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  const basePath = getCaseLink(product) + "/antrag";

  const translate = (path: string) => {
    return _get(translations, path);
  };

  const handleCheckout = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    await updateMutation.mutateAsync({
      uri: "/deaths",
      id: product.id,
      data: { personalTextMessage: formValue(values, "personalTextMessage") },
    });
    await toCheckout(product.checkoutItem.id + "_" + product.id, navigate);
  };

  return (
    <>
      <Paper elevation={4}>
        <TextContainer>
          <Typography variant={"h4"} sx={summaryStyle.headline}>
            Ihre Angaben
          </Typography>
          <Grid container>
            <CategoryData formData={values} translate={translate} />
            <PersonalData formData={values} />
          </Grid>
          <form onSubmit={handleCheckout}>
            <ValidatorTextField
              name="personalTextMessage"
              label="Ihr Anliegen"
              placeholder="Schildern Sie hier kurz Ihr Anliegen"
              InputLabelProps={{
                shrink: true,
              }}
              multiline
              rows={10}
              validators={[requiredValidator("Bitte schildern Sie uns hier kurz Ihr Anliegen.")]}
            />
            <Grid container>
              <Grid
                sx={summaryStyle.backButtonContainer}
                size={{
                  xs: 12,
                  sm: 6
                }}>
                <Button fullWidth variant={"text"} component={Link} to={basePath + "/kategorie"}>
                  Alles bearbeiten
                </Button>
              </Grid>
              <Grid
                sx={summaryStyle.submitButtonContainer}
                size={{
                  xs: 12,
                  sm: 6
                }}>
                <ButtonLoading
                  fullWidth
                  color={"primary"}
                  variant={"contained"}
                  type={"submit"}
                  isLoading={isLoading}
                  loadingText={"Dokument wird erstellt"}
                >
                  Angaben speichern
                </ButtonLoading>
              </Grid>
            </Grid>
          </form>
          <EmailVerificationModal />
        </TextContainer>
      </Paper>
    </>
  );
}
